/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type ExpectedSubdomainQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type ExpectedSubdomainQuery = {
  __typename?: 'Query'
  backofficeOrganizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    subDomain: string
  }>
}

export const ExpectedSubdomainDocument = gql`
    query ExpectedSubdomain {
  backofficeOrganizations(allOrganizations: true) {
    id
    subDomain
  }
}
    `

/**
 * __useExpectedSubdomainQuery__
 *
 * To run a query within a React component, call `useExpectedSubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpectedSubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpectedSubdomainQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpectedSubdomainQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExpectedSubdomainQuery,
    ExpectedSubdomainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ExpectedSubdomainQuery,
    ExpectedSubdomainQueryVariables
  >(ExpectedSubdomainDocument, options)
}
export function useExpectedSubdomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpectedSubdomainQuery,
    ExpectedSubdomainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ExpectedSubdomainQuery,
    ExpectedSubdomainQueryVariables
  >(ExpectedSubdomainDocument, options)
}
// @ts-ignore
export function useExpectedSubdomainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExpectedSubdomainQuery,
    ExpectedSubdomainQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExpectedSubdomainQuery,
  ExpectedSubdomainQueryVariables
>
export function useExpectedSubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExpectedSubdomainQuery,
        ExpectedSubdomainQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExpectedSubdomainQuery | undefined,
  ExpectedSubdomainQueryVariables
>
export function useExpectedSubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExpectedSubdomainQuery,
        ExpectedSubdomainQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ExpectedSubdomainQuery,
    ExpectedSubdomainQueryVariables
  >(ExpectedSubdomainDocument, options)
}
export type ExpectedSubdomainQueryHookResult = ReturnType<
  typeof useExpectedSubdomainQuery
>
export type ExpectedSubdomainLazyQueryHookResult = ReturnType<
  typeof useExpectedSubdomainLazyQuery
>
export type ExpectedSubdomainSuspenseQueryHookResult = ReturnType<
  typeof useExpectedSubdomainSuspenseQuery
>
export type ExpectedSubdomainQueryResult = Apollo.QueryResult<
  ExpectedSubdomainQuery,
  ExpectedSubdomainQueryVariables
>
